import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {TableObservationWrapper} from './component/table/observations'
import {TableInformationWrapper} from './component/table/information'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
const LaundryBatchTab = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Información de Orden de Lavado</Tab>

          <Tab className={'sdx_sub_tab_panel_option'}>Observaciones</Tab>
        </TabList>
        <TabPanel>
          <TableInformationWrapper />
        </TabPanel>

        <TabPanel>
          <TableObservationWrapper />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default LaundryBatchTab
